import React from 'react';
import PageNavigationController from 'PageNavigation/PageNavigationController';
import Page from "PageNavigation/Page";
import { dicontainer } from "DIContainer";
import IEmptyProps from "EmptyProps";
import classNames from 'classnames';
import { SimpleEventArgs } from 'ts-common-utils';

interface IContentState  {
    activePage?: Page
}

export default class Content extends React.Component<IEmptyProps, IContentState> {
    private _pageNavigationController: PageNavigationController = dicontainer.get(PageNavigationController);

    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            activePage: this._pageNavigationController.activePage
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this._pageNavigationController.onPageChange.addHandler(this.handlePageChange);
    }

    public handlePageChange(sender: object, e: SimpleEventArgs<Page>) {
        this.setState({ activePage: e.value });
    }

    public render() {
        return (
            <div className={classNames("page-content", this.state.activePage?.name)}>
                {this.state.activePage?.component}
            </div>
        );
    }
}